import gql from 'graphql-tag';

export const REMOVE_FROM_RAW_LIST = gql`
    mutation (
        $marketingCampaignId: String!
    ) {
        removeAllFromRawList (
            marketingCampaignId: $marketingCampaignId
        )
    }
`;